/* =========================================================
   RA: Hover swatch swaps product-card image (no click)
   - Swaps ALL images inside the card media (primary + secondary)
   - Delegated events (works with section loads)
   - Safe for text-node targets (prevents closest() errors)
   ========================================================= */
(function () {
  if (window.RA_SwatchHoverSwapInit) return;
  window.RA_SwatchHoverSwapInit = true;

  function canHover() {
    return window.matchMedia && window.matchMedia("(hover: hover)").matches;
  }

  function asElement(node) {
    if (node && node.nodeType === 3) return node.parentElement; // text node -> element
    return node && node.nodeType === 1 ? node : null;
  }

  function closest(el, sel) {
    if (!el || !el.closest) return null;
    return el.closest(sel);
  }

  function getCard(linkEl) {
    return closest(linkEl, ".card-wrapper");
  }

  function getImgs(cardEl) {
    if (!cardEl) return [];
    return Array.from(cardEl.querySelectorAll(".card__media img"));
  }

  function swapToVariant(linkEl) {
    var swatch = linkEl.querySelector(".ra-swatch");
    if (!swatch) return;

    var variantImg = swatch.getAttribute("data-variant-img");
    if (!variantImg) return;

    var card = getCard(linkEl);
    if (!card) return;

    var imgs = getImgs(card);
    if (!imgs.length) return;

    imgs.forEach(function (img) {
      // Save original once per image
      if (!img.dataset.raOriginalSrc) {
        img.dataset.raOriginalSrc = img.getAttribute("src") || "";
        img.dataset.raOriginalSrcset = img.getAttribute("srcset") || "";
      }

      img.setAttribute("src", variantImg);
      img.setAttribute("srcset", ""); // stop srcset overriding the new src
    });
  }

  function swapBack(linkEl) {
    var card = getCard(linkEl);
    if (!card) return;

    var imgs = getImgs(card);
    if (!imgs.length) return;

    imgs.forEach(function (img) {
      if (img.dataset.raOriginalSrc) img.setAttribute("src", img.dataset.raOriginalSrc);
      if (img.dataset.raOriginalSrcset) img.setAttribute("srcset", img.dataset.raOriginalSrcset);
    });
  }

  function getLinkFromEvent(e) {
    var el = asElement(e.target);
    if (!el) return null;
    return closest(el, ".ra-swatch-link");
  }

  document.addEventListener(
    "pointerover",
    function (e) {
      if (!canHover()) return;
      var link = getLinkFromEvent(e);
      if (!link) return;
      swapToVariant(link);
    },
    true
  );

  document.addEventListener(
    "pointerout",
    function (e) {
      if (!canHover()) return;
      var link = getLinkFromEvent(e);
      if (!link) return;

      // If moving inside the same link, ignore
      if (e.relatedTarget && link.contains(e.relatedTarget)) return;

      swapBack(link);
    },
    true
  );

  // Keyboard accessibility
  document.addEventListener(
    "focusin",
    function (e) {
      if (!canHover()) return;
      var link = getLinkFromEvent(e);
      if (!link) return;
      swapToVariant(link);
    },
    true
  );

  document.addEventListener(
    "focusout",
    function (e) {
      if (!canHover()) return;
      var link = getLinkFromEvent(e);
      if (!link) return;
      swapBack(link);
    },
    true
  );
})();